@if (content | async; as messages) {
    <vn-content-messages id="messages-with-overlay" [messages]="messages" closedCookieKey="m2" cssClassForHtmlNode="has-messages-with-overlay" />
}
